import { snakeStore } from '@app/plugins/vuex-async-pagginate';
import { DocumentService } from '@core/services/DocumentService';

export const table = snakeStore(
  {
    actions: {
      getData: (_, params) => DocumentService.getList(params)
    }
  },
  true
);
